module.exports = __webpack_public_path__ + "static/media/internal_env_2_media_9.8c66be71.webp";